<template>
  <fts-dropdown-select ref="dropdown" class="add-row-dropdown" content-class="add-row-dropdown-menu" :offset="[0, 6]"
    @show="openDropdown">
    <!-- Toggle slot: consumer provides the button -->
    <template #toggle>
      <slot name="toggle" />
    </template>

    <!-- Dropdown Content -->
    <template #menu>
      <div class="fts-form-control-filter">
        <input type="text" class="fts-form-control" v-model="search" placeholder="Search" ref="searchInput" />
        <div class="search-icon">
          <fts-spinner :size="14" v-if="searching" />
          <font-awesome-icon :icon="['fas', 'search']" fixed-width v-else />
        </div>
      </div>

      <div>
        <div class="dropdown-list">
          <div v-if="informationList.length > 0" class="dropdown-label">Informations</div>
          <div v-if="informationList.length > 0" v-for="(x, index) in informationList" :key="`${index}-information`"
            class="dropdown-option" :class="[
              x.system ? 'dropdown-option--system' : 'dropdown-option--information',
              { 'dropdown-option--active': selectedItems.some(z => z.id === x.id), 'dropdown-option--disabled': isInvalid(x, 'information') }
            ]" @click="toggleSelect(x, 'information')">
            <div class="dropdown-option-content">
              <div class="left-content">
                <div class="dropdown-option-icon" v-if="x.icon">
                  <i :class="x.icon"></i>
                </div>
                <div class="dropdown-option-label">{{ x.displayName }}</div>
              </div>
              <div class="right-icon" @click.stop>
                <fts-text-variation-modal
                  v-if="textVariationTypes.includes(x.type) && selectedItems.some(z => z.id === x.id)"
                  :initial-variation="getInformationData(x)" @select="(z) => toggleTextVariation(z, x)">
                  <template #toggle>
                    <div v-if="getInformationData(x).style || getInformationData(x).size">
                      <template v-if="getInformationData(x).style">
                        {{ mapStyle(getInformationData(x).style) }}
                      </template>
                      <template v-if="getInformationData(x).style && getInformationData(x).size"> | </template>
                      <template v-if="getInformationData(x).size">
                        {{ mapSize(getInformationData(x).size) }}
                      </template>
                    </div>
                    <font-awesome-icon class="variation-icon" v-else :icon="['fas', 'font']" />
                  </template>
                </fts-text-variation-modal>
                <fts-image-variation-modal
                  v-if="imageVariationTypes.includes(x.type) && selectedItems.some(z => z.id === x.id)"
                  :initial-variation="getInformationData(x)" @select="(z) => toggleImageVariation(z, x)">
                  <template #toggle>
                    <div v-if="getInformationData(x).ratio || getInformationData(x).orientation">
                      <template v-if="getInformationData(x).ratio">
                        {{ getInformationData(x).ratio }}
                      </template>
                      <template v-if="getInformationData(x).ratio && getInformationData(x).orientation"> | </template>
                      <template v-if="getInformationData(x).orientation">
                        {{ mapOrientation(getInformationData(x).orientation) }}
                      </template>
                    </div>
                    <font-awesome-icon class="variation-icon" v-else :icon="['fas', 'border-none']" />
                  </template>
                </fts-image-variation-modal>
              </div>
            </div>
          </div>

          <div v-if="activityList.length > 0" class="dropdown-label">Activities</div>
          <div v-if="activityList.length > 0" v-for="(x, index) in activityList" :key="`${index} -activity`"
            class="dropdown-option" :class="[
              x.system ? 'dropdown-option--system' : 'dropdown-option--information',
              { 'dropdown-option--active': selectedItems.some(z => z.id === x.id), 'dropdown-option--disabled': isInvalid(x, 'activity') }
            ]" @click="toggleSelect(x, 'activity')">
            <div>{{ x.name }}</div>
          </div>

          <div v-if="widgetList.length > 0" class="dropdown-label">Widgets</div>
          <div v-if="widgetList.length > 0" v-for="(x, index) in widgetList" :key="`${index}-widget`"
            class="dropdown-option" :class="[
              x.system ? 'dropdown-option--system' : 'dropdown-option--information',
              { 'dropdown-option--active': selectedItems.some(z => z.id === x.id), 'dropdown-option--disabled': isInvalid(x, 'widget') }
            ]" @click="toggleSelect(x, 'widget')">
            <div>{{ x.name }}</div>
          </div>


          <div class="dropdown-no-results" v-if="!informationList.length && !searching">
            No results found
          </div>

        </div>
        <div class="button-wrapper">
          <button type="button" class="fts-btn fts-btn-raised fts-btn-primary" @click="confirmSelection">
            <font-awesome-icon :icon="['fas', 'check']" fixed-width />Save
          </button>
        </div>
      </div>


    </template>
  </fts-dropdown-select>
</template>


<script>
import FTSToggleSwitch from '../elements/FTSToggleSwitch';
import FTSDropdownSelect from "../elements/FTSDropdownSelect";
import FTSLabelGroup from '../elements/FTSLabelGroup';
import FTSTextVariationDropdown from '../elements/FTSTextVariationDropdown';
import FTSImageVariationDropdown from '../elements/FTSImageVariationDropdown';
import commons from '../commons/commons';

export default {
  name: 'RowAddDropdown',
  components: {
    'fts-toggle-switch': FTSToggleSwitch,
    "fts-dropdown-select": FTSDropdownSelect,
    'fts-label-group': FTSLabelGroup,
    'fts-text-variation-modal': FTSTextVariationDropdown,
    'fts-image-variation-modal': FTSImageVariationDropdown,
  },
  props: {
    invalidOptions: Array,
    informations: Array,
    activities: Array,
    initialSelected: Array,
  },
  emits: ['select'],
  data() {
    return {
      textVariationTypes: [0, 2, 3, 4, 5, 6, 7, 8, 9, 16, 20, 21, 25, 26, 27, 28, 33],
      imageVariationTypes: [10, 11],
      search: '',
      searching: false,
      selectedItems: [],
      widgets: [
        { 'id': 'defaultCard', 'name': 'Default Card' },
      ],
    };
  },
  computed: {
    informationList() {
      const query = this.search.toLowerCase();
      return this.informations
        .filter(item => item.displayName.toLowerCase().includes(query))
        .map(item => ({
          ...item,
          icon: commons.informationIcon(item.type),
        }));
    },
    activityList() {
      const query = this.search.toLowerCase();
      return this.activities
        .filter(item => item.name.toLowerCase().includes(query))
        .map(item => ({
          ...item,
        }));
    },
    widgetList() {
      const query = this.search.toLowerCase();
      return this.widgets
        .filter(item => item.name.toLowerCase().includes(query))
        .map(item => ({
          ...item,
        }));
    },
  },
  methods: {
    mapStyle(style) {
      switch (style) {
        case 'b': return 'Bold';
        case 'l': return 'Light';
        default: return '';
      }
    },
    mapSize(size) {
      // Allow S, M, L to pass through
      return size;
    },
    mapOrientation(orientation) {
      switch (orientation) {
        case 'portrait': return 'Portrait';
        default: return '';
      }
    },
    getInformationData(item) {
      const index = this.selectedItems.findIndex(x => x.id === item.id && x.type === 'information');
      return this.selectedItems[index];
    },
    isInvalid(x, type) {
      if (this.invalidOptions.some(z => z.id === x.id)) return true;
      if (this.selectedItems.some(z => z.id === x.id)) return false;

      // single restricted
      if (type == 'information' && [10, 11, 22].includes(this.informations.find(y => y.id === x.id).type)) {
        if (this.selectedItems.length > 0) return true;
      }

      if (type == 'widget' && this.selectedItems.length > 0) {
        return true;
      }

      // general restricted
      if (this.selectedItems.some(z => z.type === 'information' && [10, 11].includes(this.informations.find(y => y.id === z.id).type))) return true;
      if (this.selectedItems.length >= 3) return true;
      if (this.selectedItems.some(z => z.type === 'widget')) return true;

      return false;
    },
    openDropdown() {
      this.search = '';
      this.searching = false;
      this.selectedItems = [...(this.initialSelected || [])];
    },
    toggleSelect(item, type) {
      if (this.isInvalid(item, type)) return;

      const data = { type, id: item.id };

      const index = this.selectedItems.findIndex(x => x.id === item.id && x.type === type);

      if (index !== -1) {
        this.selectedItems.splice(index, 1); // Remove if exists
      } else {
        this.selectedItems.push(data); // Add if not exists
      }
    },
    confirmSelection() {
      this.$emit('select', [...this.selectedItems]);
      this.$refs.dropdown.$refs.popper.doClose();
    },
    toggleTextVariation(v, item) {
      console.log(v, item);
      const index = this.selectedItems.findIndex(x => x.id === item.id && x.type === 'information'); // 修正 type

      if (index !== -1) {
        const current = { ...this.selectedItems[index] };

        if (v.size != null) {
          current.size = v.size;
        } else if ('size' in current) {
          delete current.size;
        }

        if (v.style != null) {
          current.style = v.style;
        } else if ('style' in current) {
          delete current.style;
        }

        this.$set(this.selectedItems, index, current);

      }
      console.log(this.selectedItems[index]);
    },
    toggleImageVariation(v, item) {
      console.log(v, item);
      const index = this.selectedItems.findIndex(x => x.id === item.id && x.type === 'information'); // 修正 type

      if (index !== -1) {
        const current = { ...this.selectedItems[index] };

        if (v.ratio != null) {
          current.ratio = v.ratio;
        } else if ('ratio' in current) {
          delete current.ratio;
        }

        if (v.orientation != null) {
          current.orientation = v.orientation;
        } else if ('orientation' in current) {
          delete current.orientation;
        }

        this.$set(this.selectedItems, index, current);

      }
      console.log(this.selectedItems[index]);
    }
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";


.fts-form-control-filter {
  margin-bottom: 0.5rem;
  margin: 0.4rem 0.4rem;
}

.dropdown-list {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  max-height: 30rem;
  overflow-y: scroll;
  overflow-x: hidden;
}


.dropdown-option-content {
  width: 90%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-content {
  display: flex;
  align-items: center;
  gap: 8px;
  /* spacing between icon and label */
}

.right-icon {
  margin-left: auto;
}

.dropdown-no-results {
  text-align: center;
  color: #888;
  font-size: 0.85rem;
  margin-top: 0.5rem;
}


.add-row-dropdown-menu {
  min-height: 50px;
  padding: 0.5rem;
  background: #fff;
  border: 1px solid #ddd;
  text-align: center;
  color: #aaa;
}

.variation-icon {
  color: var(--fts-default)
}

.button-wrapper {
  bottom: 0;
  right: 0;
  padding-top: 1rem;
}
</style>
